export default {
  title: 'Impressum',
  subtitle: 'Tilpas oplysningerne i dit butiksimpressum uden at ændre din virksomhedsprofil.',
  defaultsNotice:
    'Alle felter er valgfrie. Lad et felt stå tomt for fortsat at bruge værdien fra din virksomhedsprofil – den nuværende standard vises med grå tekst som forhåndsvisning. Hvis du udfylder et felt, ændres kun impressummet; din virksomhedsprofil forbliver uændret.',
  fields: {
    legal_name: {
      label: 'Firmanavn / juridisk navn',
      placeholder: 'f.eks. Musterbetrieb GmbH',
    },
    owner_first_name: {
      label: 'Ejerens fornavn',
      placeholder: 'f.eks. Alex',
    },
    owner_last_name: {
      label: 'Ejerens efternavn',
      placeholder: 'f.eks. Müller',
    },
    owner_email: {
      label: 'E-mail',
      placeholder: 'f.eks. info@example.com',
      invalid: 'Indtast en gyldig e-mailadresse',
    },
    owner_phone_number: {
      label: 'Telefon',
      placeholder: 'f.eks. +49 30 1234567',
    },
    tax_id: {
      label: 'Skatte-ID',
      placeholder: 'f.eks. DE123456789',
    },
    address: {
      label: 'Adresse',
      placeholder: 'Gade, postnummer, by',
    },
  },
  buttons: {
    save: 'Gem',
  },
  toasts: {
    saved: 'Impressum gemt',
    failed: 'Impressum kunne ikke gemmes',
  },
};
